<div class="page-container gap-24">
  <div class="page-title">Über unsere Philosophie</div>
  <app-title-card id="title-card" [titleCard]="titleCard"></app-title-card>
  <span class="align-self-stretch subtitle">
    Unser Leitbild und unsere Philosophie – Fortbildungsinstitut InWi
  </span>
  <span class="align-self-stretch font-regular-body-large">
    Bei InWi stehen Qualität und evidenzbasierte Inhalte im Mittelpunkt unserer
    Arbeit. Unser Ziel ist es, aktuelles Wissen für alle zugänglich zu machen –
    und das zu fairen Preisen. Gleichzeitig schätzen wir die Expertise unserer
    Dozierenden und bieten ihnen eine angemessene Vergütung für ihre wertvolle
    Arbeit.
  </span>
  <span class="align-self-stretch subtitle"> Unser Versprechen: </span>
  <span class="align-self-stretch">
    <ul>
      <li>
        <span class="font-bold-body-large"> Qualität und Evidenz: </span>
        <span class="font-regular-body-large">
          Wir garantieren hochwertige Fortbildungen und Vorträge durch
          regelmäßigen Austausch und sorgfältige Sichtung der Präsentationen. So
          stellen wir sicher, dass unsere Inhalte stets aktuell und
          wissenschaftlich fundiert sind.
        </span>
      </li>
      <li>
        <span class="font-bold-body-large"> Aktualität: </span>
        <span class="font-regular-body-large">
          Unsere Fortbildungen werden regelmäßig gemäß den neuesten Leitlinien
          und anderen evidenzbasierten Quellen aktualisiert. So bleibst du immer
          auf dem neuesten Stand.
        </span>
      </li>
      <li>
        <span class="font-bold-body-large"> Zugang für alle: </span>
        <span class="font-regular-body-large">
          Wissen sollte kein Luxus sein. Daher bieten wir unsere Fortbildungen
          zu erschwinglichen Preisen an, um möglichst vielen Menschen den Zugang
          zu hochwertiger Bildung zu ermöglichen.
        </span>
      </li>
      <li>
        <span class="font-bold-body-large">
          Unterstützung der Dozierenden:
        </span>
        <span class="font-regular-body-large">
          Wir wissen, wie wichtig engagierte und kompetente Dozierende sind.
          Deshalb bieten wir ihnen nicht nur eine faire Bezahlung, sondern auch
          umfassende Unterstützung bei der Erstellung und Durchführung ihrer
          Fortbildungen.
        </span>
      </li>
      <li>
        <span class="font-bold-body-large"> Umfassende Materialien: </span>
        <span class="font-regular-body-large">
          Über die Fortbildung hinaus stellen wir dir in unserer Bibliothek eine
          Fülle an zusätzlichen Materialien zur Verfügung. Diese Ressourcen
          sollen dich im therapeutischen Alltag unterstützen und dein Wissen
          vertiefen.
        </span>
      </li>
    </ul>
  </span>
  <span class="align-self-stretch">
    <span class="font-regular-body-large">
      Bei InWi verbinden wir wissenschaftliche Exzellenz mit praxisnaher
      Anwendbarkeit und sozialer Verantwortung. Wir sind stolz darauf, eine
      Plattform zu bieten, die sowohl Lernenden als auch Dozierenden gerecht
      wird und zu einer besseren, evidenzbasierten Praxis beiträgt.
    </span>
  </span>
</div>
